<template>
  <div class="overflow-x-scroll">
    <table
      :aria-label="i18n(translations.tableTitle)"
      class="m-0 w-full border-collapse overflow-x-scroll whitespace-nowrap border-0 p-0"
    >
      <thead class="text-left">
        <tr class="border-static-default-low border-b">
          <th class="w-[11%] px-16 py-12" scope="col">
            <div class="flex items-center space-x-8">
              <span> {{ i18n(translations.statusHeader) }} </span>

              <RevTooltip content-class-names="max-w-none" position="right">
                <template #trigger="{ show, hide }">
                  <IconInfo
                    class="align-middle"
                    @focusin="show"
                    @focusout="hide"
                    @mouseleave="hide"
                    @mouseover="show"
                  />
                </template>

                {{ i18n(translations.statusTooltip) }}
              </RevTooltip>
            </div>
          </th>
          <th class="w-[14%] px-16 py-12" scope="col">
            {{ i18n(translations.taskHeader) }}
          </th>
          <th class="w-[16%] px-16 py-12" scope="col">
            {{ i18n(translations.lastActionTakenHeader) }}
          </th>
          <th class="w-[16%] px-16 py-12" scope="col">
            {{ i18n(translations.issueTypeHeader) }}
          </th>
          <th class="w-[9%] px-16 py-12" scope="col">
            {{ i18n(translations.orderIdHeader) }}
          </th>
          <th class="w-[16%] px-16 py-12" scope="col">
            {{ i18n(translations.customerHeader) }}
          </th>
          <th
            class="w-[11%] px-16 py-12"
            data-test="upload-receipt-button"
            scope="col"
          >
            <span class="sr-only">
              {{ i18n(translations.uploadReceiptHeader) }}
            </span>
          </th>
          <th
            class="w-[6%] px-16 py-12"
            data-test="conversation-link"
            scope="col"
          >
            <span class="sr-only">{{ i18n(translations.actionsHeader) }}</span>
          </th>
        </tr>
      </thead>

      <tbody>
        <AllRequestsRow
          v-for="request in requests"
          :key="request.id"
          :request
        />
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTooltip } from '@ds/components/Tooltip'
import { IconInfo } from '@ds/icons/IconInfo'

import type { Request } from '~/api/seller-after-sales/types/requests.types'

import AllRequestsRow from './AllRequestsRow/AllRequestsRow.vue'
import translations from './AllRequestsTable.translations'

defineProps<{ requests: Request[] }>()

const i18n = useI18n()
</script>
